import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=04dffc98&scoped=true"
import script from "./orderDetail.vue?vue&type=script&lang=js"
export * from "./orderDetail.vue?vue&type=script&lang=js"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=04dffc98&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dffc98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04dffc98')) {
      api.createRecord('04dffc98', component.options)
    } else {
      api.reload('04dffc98', component.options)
    }
    module.hot.accept("./orderDetail.vue?vue&type=template&id=04dffc98&scoped=true", function () {
      api.rerender('04dffc98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myDealChild/child/orderDetail.vue"
export default component.exports